var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"documents"},[_c('section',{staticClass:"content-header"},[_c('h1',[_vm._v(_vm._s(_vm.$t('menu.documents')))])]),_c('section',{staticClass:"content"},[_c('browser-file')],1)])}
var staticRenderFns = []

export { render, staticRenderFns }